module.exports = __webpack_public_path__ + "img/koa@2x.6a48e98e.png";